export const ZIP_LENGTH = 5;

export const isValidZipcode = (zip: string | undefined): boolean => {
  if (zip) {
    return new RegExp(`^\\d{${ZIP_LENGTH}}$`).test(zip);
  }
  return false;
};
